import { useEffect, useState } from "react";
import { type Hex, parseColor } from "@/color/oklch";
import { cn } from "@/ui/kit/cn";

/** Text input that accepts hex, rgb(), hsl(), oklch() or a color name. */
export function ColorField({
  value,
  onChange,
  className,
}: {
  value: Hex;
  onChange: (hex: Hex) => void;
  className?: string;
}) {
  const [text, setText] = useState<string>(value);
  const [bad, setBad] = useState(false);
  useEffect(() => {
    setText(value);
    setBad(false);
  }, [value]);

  const commit = (raw = text) => {
    const hex = parseColor(raw);
    if (!hex) return setBad(true);
    setBad(false);
    if (hex !== value) onChange(hex);
    setText(hex);
  };

  return (
    <input
      aria-label="Color value"
      spellCheck={false}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={() => commit()}
      onKeyDown={(e) => {
        // Enter commits and leaves the field, so Ctrl+Z then undoes the edit app-wide.
        if (e.key === "Enter") e.currentTarget.blur();
        if (e.key === "Escape") {
          setText(value);
          e.currentTarget.blur();
        }
      }}
      onPaste={(e) => {
        const pasted = e.clipboardData.getData("text");
        if (parseColor(pasted)) {
          e.preventDefault();
          commit(pasted);
        }
      }}
      className={cn(
        "h-8 w-full rounded-md border bg-bg px-2 font-mono text-sm outline-none focus:border-accent",
        bad ? "border-danger" : "border-line",
        className,
      )}
    />
  );
}
